<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h4 class="m-0">Outbound Transaction 2</h4>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link to="/dashboard">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">
                <router-link to="/outbound-transcation"
                  >Outbound Transaction</router-link
                >
              </li>
              <li class="breadcrumb-item active">
                <span>Transaction 2</span>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-12">
            <div class="card card-plb">
              <div class="card-header ui-sortable-handle">
                <h5 class="card-title card_title_margin">
                  <i class="nav-icon fa-solid fa-money-bill-transfer"></i>
                  Outbound Transaction 2
                </h5>
                <div class="card-tools">
                  <button
                    type="button"
                    data-card-widget="collapse"
                    class="btn btn-tool"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
              </div>
              <!-- BEGIN: Card Body -->
              <div class="card-body">
                <!-- BEGIN: Cari Data -->
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <form @submit.prevent class="form-horizontal">
                      <div class="form-group row mt-4">
                        <label class="col-sm-3 col-form-label"
                          >Tanggal Outbound</label
                        >
                        <div class="col-sm-4">
                          <datepicker
                            input-class="form-control"
                            placeholder="Dari Tanggal"
                            format="dd/MM/yyyy"
                            v-model="filter_start_date_outbound"
                            autofocus
                          />
                        </div>
                        <div class="col-sm-4">
                          <datepicker
                            input-class="form-control"
                            placeholder="Sampai Tanggal"
                            format="dd/MM/yyyy"
                            v-model="filter_end_date_outbound"
                          />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-sm-3 col-form-label"
                          >Tanggal AJU</label
                        >
                        <div class="col-sm-4">
                          <datepicker
                            input-class="form-control"
                            placeholder="Dari Tanggal"
                            format="dd/MM/yyyy"
                            v-model="filter_start_date_aju"
                            autofocus
                          />
                        </div>
                        <div class="col-sm-4">
                          <datepicker
                            input-class="form-control"
                            placeholder="Sampai Tanggal"
                            format="dd/MM/yyyy"
                            v-model="filter_end_date_aju"
                          />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-sm-3 col-form-label"
                          >Jenis Dokumen</label
                        >
                        <div class="col-sm-2">
                          <label class="control-label" style="margin-top: 5px">
                            <input
                              type="checkbox"
                              id="BC27"
                              value="BC27"
                              v-model="filter_jenis_bc"
                            />
                            27
                          </label>
                        </div>
                        <div class="col-sm-2">
                          <label class="control-label" style="margin-top: 5px">
                            <input
                              type="checkbox"
                              id="BC28"
                              value="BC28"
                              v-model="filter_jenis_bc"
                            />
                            28
                          </label>
                        </div>
                        <div class="col-sm-2">
                          <label class="control-label" style="margin-top: 5px">
                            <input
                              type="checkbox"
                              id="BC30"
                              value="BC30"
                              v-model="filter_jenis_bc"
                            />
                            30
                          </label>
                        </div>
                        <div class="col-sm-2">
                          <label class="control-label" style="margin-top: 5px">
                            <input
                              type="checkbox"
                              id="BC41"
                              value="BC41"
                              v-model="filter_jenis_bc"
                            />
                            41
                          </label>
                        </div>
                      </div>
                      <div class="form-group row justify-content-center">
                        <div class="col-sm-6">
                          <button class="btn btn-primary" @click="filterButton">
                            <i class="fa-solid fa-magnifying-glass"></i>
                            Filter
                          </button>
                          <button class="btn btn-secondary" @click="clearForm">
                            <i class="fa-solid fa-rotate"></i> Reset
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <!-- END: Cari Data -->
                <hr />

                <!-- BEGIN: Tampil Data -->
                <div class="form-group mt-4">
                  <div class="vgt-wrap polar-bear">
                    <div class="vgt-inner-wrap">
                      <!-- BEGIN: Global Search -->
                      <div class="vgt-global-search vgt-clearfix">
                        <div class="vgt-global-search__input vgt-pull-left">
                          <label>
                            <span aria-hidden="true" class="input__icon">
                              <div class="magnifying-glass"></div>
                            </span>
                            <span class="sr-only"> Search </span>
                          </label>
                          <input
                            type="text"
                            placeholder="Search Data"
                            class="vgt-input vgt-pull-left"
                            v-model="search"
                            @change="list()"
                          />
                        </div>
                        <!-- <div
                          class="vgt-global-search__actions vgt-pull-right"
                          v-if="$gate.isAdminOrPlanner()"
                        > -->
                        <div class="vgt-global-search__actions vgt-pull-right">
                          <div>
                            <button
                              class="btn btn-secondary ms-auto rounded-1"
                              @click="exportCsv"
                            >
                              <i class="fa-solid fa-file-csv"></i>
                              CSV
                            </button>
                            <button
                              class="btn btn-secondary ms-auto rounded-1"
                              style="margin-right: 10px"
                              @click="exportExcel"
                            >
                              <i class="fa-solid fa-file-excel"></i>
                              Excel
                            </button>
                            <!-- <button
                              class="btn btn-secondary ms-auto rounded-1"
                              style="margin-right: 10px"
                            >
                              <i class="fa-solid fa-file-pdf"></i>
                              PDF
                            </button> -->
                          </div>
                        </div>
                        <!-- <div
                          class="vgt-global-search__actions vgt-pull-right"
                          v-else
                          style="margin-right: 5px"
                        ></div> -->
                      </div>
                      <!-- END: Global Search -->

                      <!-- BEGIN: Table -->
                      <div class="vgt-responsive">
                        <table
                          id="vgt-table"
                          class="vgt-table bordered polar-bear"
                        >
                          <thead>
                            <!-- !BEGIN: Header Table -->
                            <tr>
                              <!-- BEGIN: Number -->
                              <th class="text-center">
                                <span class="table_header">No.</span>
                              </th>
                              <!-- END: Number  -->

                              <!-- *BEGIN: Kode Barang Header -->
                              <th
                                v-if="order == 'KODE_BARANG' && by == 'asc'"
                                @click="sort('KODE_BARANG', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Kode Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'KODE_BARANG' && by == 'desc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Kode Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('KODE_BARANG', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Kode Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- *END: Kode Barang Header -->

                              <!-- *BEGIN: Nama Barang Header -->
                              <th
                                v-if="order == 'NAMA_BARANG' && by == 'asc'"
                                @click="sort('NAMA_BARANG', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Nama Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'NAMA_BARANG' && by == 'desc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Nama Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('NAMA_BARANG', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Nama Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- *END: Nama Barang Header -->

                              <!-- BEGIN: Satuan Header -->
                              <th
                                v-if="order == 'SATUAN' && by == 'asc'"
                                @click="sort('SATUAN', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Satuan</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="order == 'SATUAN' && by == 'desc'"
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Satuan</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('SATUAN', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Satuan</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- *END: Satuan Header -->

                              <!-- *BEGIN: Jumlah Barang Header -->
                              <th
                                v-if="order == 'JUMLAH_BARANG' && by == 'asc'"
                                @click="sort('JUMLAH_BARANG', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Jumlah Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'JUMLAH_BARANG' && by == 'desc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Jumlah Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('JUMLAH_BARANG', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Jumlah Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- *END: Jumlah Barang Header -->

                              <!-- *BEGIN: Jenis Dokumen Header -->
                              <th
                                v-if="order == 'JENIS_BC' && by == 'asc'"
                                @click="sort('JENIS_BC', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Jenis Dokumen</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="order == 'JENIS_BC' && by == 'desc'"
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Jenis Dokumen</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('JENIS_BC', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Jenis Dokumen</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- *END: Jenis Dokumen Header -->

                              <!-- * BEGIN: Register A/C Header -->
                              <th
                                v-if="
                                  order == 'AIRCRAFT_REGISTRATION' &&
                                  by == 'asc'
                                "
                                @click="sort('AIRCRAFT_REGISTRATION', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Register A/C</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'AIRCRAFT_REGISTRATION' &&
                                  by == 'desc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Register A/C</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('AIRCRAFT_REGISTRATION', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Register A/C</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- *END: Register A/C Header -->

                              <!-- BEGIN: Nama Airlines Header -->
                              <th
                                v-if="order == 'NAMA_AIRLINES' && by == 'asc'"
                                @click="sort('NAMA_AIRLINES', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Customer</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'NAMA_AIRLINES' && by == 'desc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Customer</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('NAMA_AIRLINES', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Customer</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Nama Airlines Header -->

                              <!-- BEGIN: Tanggal Pengeluaran Header -->
                              <th
                                v-if="
                                  order == 'TANGGAL_PENGELUARAN' && by == 'asc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header"
                                  >Tanggal Pengeluaran</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'TANGGAL_PENGELUARAN' && by == 'desc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header"
                                  >Tanggal Pengeluaran</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('TANGGAL_PENGELUARAN', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header"
                                  >Tanggal Pengeluaran</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- *END: Tanggal Pengeluaran Header -->

                              <!-- *BEGIN: Date A/C IN Header -->
                              <!-- <th
                                v-if="
                                  order == 'date_aircraft_in' && by == 'asc'
                                "
                                @click="sort('date_aircraft_in', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Date A/C In</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'date_aircraft_in' && by == 'desc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Date A/C In</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('date_aircraft_in', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Date A/C In</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th> -->
                              <!-- *END: Date A/C IN Header -->

                              <!-- *BEGIN: Date A/C Out Header -->
                              <th
                                v-if="
                                  order == 'DATE_AIRCRAFT_OUT' && by == 'asc'
                                "
                                @click="sort('DATE_AIRCRAFT_OUT', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Date A/C Out</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'DATE_AIRCRAFT_OUT' && by == 'desc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Date A/C Out</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('DATE_AIRCRAFT_OUT', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Date A/C Out</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- *END: Date A/C OUT Header -->

                              <!-- *BEGIN: Nomor AJU Header -->
                              <th
                                v-if="order == 'NOMOR_AJU' && by == 'asc'"
                                @click="sort('NOMOR_AJU', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Nomor AJU</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="order == 'NOMOR_AJU' && by == 'desc'"
                                @click="sort('TANGGAL_PENGELUARAN', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Nomor AJU</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('NOMOR_AJU', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Nomor AJU</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- *END: Nomor AJU Header -->

                              <!-- *BEGIN: Nomor Daftar Header -->
                              <th
                                v-if="order == 'NOMOR_DAFTAR' && by == 'asc'"
                                @click="sort('NOMOR_DAFTAR', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Nomor Daftrar</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="order == 'NOMOR_DAFTAR' && by == 'desc'"
                                @click="sort('TANGGAL_PENGELUARAN', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Nomor Daftar</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('NOMOR_DAFTAR', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Nomor Daftar</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- *END: Nomor Daftar Header -->

                              <!-- *BEGIN: Tanggal Daftar Header -->
                              <th
                                v-if="order == 'TANGGAL_DAFTAR' && by == 'asc'"
                                @click="sort('TANGGAL_DAFTAR', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Tanggal Daftar</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="order == 'TANGGAL_DAFTAR' && by == 'desc'"
                                @click="sort('TANGGAL_PENGELUARAN', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Tanggal Daftar</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('TANGGAL_DAFTAR', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Tanggal Daftar</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- *END: Tanggal Daftar Header -->

                              <!-- *BEGIN: Matdoc Item Header -->
                              <th
                                v-if="order == 'MATDOC_ITEM' && by == 'asc'"
                                @click="sort('MATDOC_ITEM', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Matdoc Item</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="order == 'MATDOC_ITEM' && by == 'desc'"
                                @click="sort('TANGGAL_PENGELUARAN', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Matdoc Item</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('MATDOC_ITEM', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Matdoc Item</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- *END: Matdoc Item Header -->

                              <!-- *BEGIN: Tanggal TTD Header -->
                              <th
                                v-if="order == 'TANGGAL_TTD' && by == 'asc'"
                                @click="sort('TANGGAL_TTD', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Tanggal TTD</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'TANGGAL_TTD' && by == 'desc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Tanggal TTD</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('TANGGAL_TTD', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Tanggal TTD</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- *END: Tanggal TTD Header -->

                              <!-- *BEGIN: CIF RUPIAH Header -->
                              <th
                                v-if="order == 'CIF_RUPIAH' && by == 'asc'"
                                @click="sort('CIF_RUPIAH', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">CIF IDR</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'CIF_RUPIAH' && by == 'desc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">CIF IDR</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('CIF_RUPIAH', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">CIF IDR</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- *END: CIF RUPIAH Header -->

                              <!-- *BEGIN: BM Dibayar Header -->
                              <!-- <th class="text-center">
                                <span class="table_header">BM Dibayar</span>
                              </th> -->
                              <!-- *END: BM Dibayar Header -->

                              <!-- *BEGIN: PPn Dibayar Header -->
                              <!-- <th class="text-center">
                                <span class="table_header">PPn Dibayar</span>
                              </th> -->
                              <!-- *END: PPn Dibayar Header -->

                              <!-- *BEGIN: PPh Dibayar Header -->
                              <!-- <th class="text-center">
                                <span class="table_header">PPh Dibayar</span>
                              </th> -->
                              <!-- *END: PPh Dibayar Header -->
                            </tr>
                            <!-- *END: Header Table -->

                            <!-- !BEGIN: Search Table -->
                            <tr>
                              <!-- BEGIN: Filter Number -->
                              <th class="filter-th"></th>
                              <!-- END: Filter Number -->

                              <!-- *BEGIN: Kode Barang Search -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Search..."
                                    v-model="search_kode_barang"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- *END: Kode Barang Search -->

                              <!-- *BEGIN: Nama Barang Search -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Search..."
                                    v-model="search_nama_barang"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- *END: Nama Barang Search -->

                              <!-- *BEGIN: Satuan Search -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Search..."
                                    v-model="search_satuan"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- *END: Satuan Search -->

                              <!-- *BEGIN: Jumlah Barang Search -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Search..."
                                    v-model="search_jumlah_barang"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- *END: Jumlah Barang Search -->

                              <!-- *BEGIN: Jenis BC Search -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Search..."
                                    v-model="search_jenis_bc"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- *END: Jenis BC Search -->

                              <!-- *BEGIN: Register A/C Search -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Search..."
                                    v-model="search_aircraft_registration"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- *END: Register A/C Search -->

                              <!-- *BEGIN: Costumer Search -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Search..."
                                    v-model="search_nama_airlines"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- *END: Costumer Search -->

                              <!-- *BEGIN: Tanggal Pengeluaran Search -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="date"
                                    class="vgt-input"
                                    placeholder="Search..."
                                    v-model="search_tanggal_pengeluaran"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- *END: Tanggal Pengeluaran Search -->

                              <!-- *BEGIN: Tanggal Aircraft IN Search -->
                              <!-- <th class="filter-th">
                                <div>
                                  <input
                                    type="date"
                                    class="vgt-input"
                                    placeholder="Date A/C In"
                                    v-model="search_date_aircraft_in"
                                    @change="list()"
                                  />
                                </div>
                              </th> -->
                              <!-- *END: Tanggal Aircraft IN Search -->

                              <!-- *BEGIN: Tanggal Aircraft OUT Search -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="date"
                                    class="vgt-input"
                                    placeholder="Date A/C Out"
                                    v-model="search_date_aircraft_out"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- *END: Tanggal Aircraft OUT Search -->

                              <!-- *BEGIN: Nomor AJU Search -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Search..."
                                    v-model="search_nomor_aju"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- *END: Nomor AJU Search -->

                              <!-- *BEGIN: Nomor Daftar Search -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Search..."
                                    v-model="search_nomor_daftar"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- *END: Nomor Daftar Search -->

                              <!-- *BEGIN: Tanggal Daftar Search -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="date"
                                    class="vgt-input text-center"
                                    placeholder="Search..."
                                    v-model="search_tanggal_daftar"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- *END: Tanggal Daftar Search -->

                              <!-- *BEGIN: Matdoc Item Search -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Search..."
                                    v-model="search_matdoc_item"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- *END: Matdoc Item Search -->

                              <!-- *BEGIN: Tanggal TTD Search -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="date"
                                    class="vgt-input text-center"
                                    placeholder="Search..."
                                    v-model="search_tanggal_ttd"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- *END: Tanggal TTD Search -->

                              <!-- *BEGIN: CIF Rupiah Search -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="CIF IDR"
                                    v-model="search_cif_rupiah"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- *END: CIF Rupiah Search -->

                              <!-- <th class="filter-th"></th>
                              <th class="filter-th"></th>
                              <th class="filter-th"></th> -->
                            </tr>
                          </thead>
                          <tbody>
                            <!-- BEGIN: Tampil Data -->
                            <tr
                              v-for="(
                                outbound, outbound_index
                              ) in outbounds.data"
                              :key="outbound_index"
                            >
                              <td class="text-center table-content">
                                {{ outbounds.from + outbound_index }}
                              </td>
                              <td class="text-center table_content">
                                {{ outbound.KODE_BARANG || '-' }}
                              </td>
                              <td class="text-center table_content">
                                {{ outbound.NAMA_BARANG || '-' }}
                              </td>
                              <!-- BEGIN : Satuan -->
                              <td class="text-center table_content">
                                {{ outbound.SATUAN || '-' }}
                              </td>
                              <!-- END : Satuan -->
                              <!-- BEGIN : Jumlah Barang -->
                              <td class="text-center table_content">
                                {{ outbound.JUMLAH_BARANG || '-' }}
                              </td>
                              <!-- END : Jumlah Barang -->
                              <!-- *BEGIN: Jenis Dokumen -->
                              <td class="text-center table_content">
                                {{ outbound.JENIS_BC || '-' }}
                              </td>
                              <!-- *END: Jenis Dokumen -->
                              <!-- *BEGIN : Register Aircraft -->
                              <td class="text-center table_content">
                                {{ outbound.AIRCRAFT_REGISTRATION || '-' }}
                              </td>
                              <!-- END : Register Aircraft -->
                              <td class="text-center table_content">
                                {{ outbound.NAMA_AIRLINES || '-' }}
                              </td>

                              <td
                                v-if="outbound.TANGGAL_PENGELUARAN === null"
                                class="text-center table_content"
                              >
                                -
                              </td>
                              <td class="table_content text-center">
                                {{ outbound.TANGGAL_PENGELUARAN | myDate }}
                              </td>
                              <!-- <td class="table_content text-center">
                                {{ outbound.DATE_AIRCRAFT_IN | myDateTime }}
                              </td> -->
                              <td
                                v-if="outbound.DATE_AIRCRAFT_OUT === null"
                                class="text-center table_content"
                              >
                                -
                              </td>
                              <td class="table_content text-center" v-else>
                                {{ outbound.DATE_AIRCRAFT_OUT | myDate }}
                              </td>

                              <td class="table_content text-center">
                                {{ outbound.NOMOR_AJU || '-' }}
                              </td>

                              <td class="text-center table_content">
                                {{ outbound.NOMOR_DAFTAR || '-' }}
                              </td>

                              <td
                                v-if="outbound.TANGGAL_DAFTAR === null"
                                class="text-center table_content"
                              >
                                -
                              </td>
                              <td class="text-center table_content" v-else>
                                {{ outbound.TANGGAL_DAFTAR | myDate }}
                              </td>

                              <td class="text-center table_content">
                                {{ outbound.MATDOC_ITEM || '-' }}
                              </td>

                              <td
                                v-if="outbound.TANGGAL_TTD === null"
                                class="text-center table_content"
                              >
                                -
                              </td>
                              <td class="table_content text-center" v-else>
                                {{ outbound.TANGGAL_TTD | myDate }}
                              </td>

                              <td
                                v-if="outbound.CIF_RUPIAH === null"
                                class="text-center table_content"
                              >
                                -
                              </td>
                              <td class="text-center table_content" v-else>
                                {{ outbound.CIF_RUPIAH | formatNumber }}
                              </td>

                              <!-- <td class="table_content text-center">
                                <span v-if="outbound.JENIS_TARIF == 'BM'">{{
                                  outbound.TARIF
                                }}</span>
                                <span v-else>-</span>
                              </td>
                              <td class="table_content text-center">
                                <span v-if="outbound.JENIS_TARIF == 'PPN'">{{
                                  outbound.TARIF
                                }}</span>
                                <span v-else>-</span>
                              </td>
                              <td class="table_content text-center">
                                <span v-if="outbound.JENIS_TARIF == 'PPH'">{{
                                  outbound.TARIF
                                }}</span>
                                <span v-else>-</span>
                              </td> -->
                            </tr>
                            <!-- END: Tampil Data -->
                            <!-- BEGIN: Data Kosong -->
                            <tr v-if="outbounds.data.length < 1">
                              <td colspan="16">
                                <div class="vgt-center-align vgt-text-disabled">
                                  Data not found
                                </div>
                              </td>
                            </tr>
                            <!-- END: Data Kosong -->
                          </tbody>
                        </table>
                      </div>
                      <!-- END: Table -->

                      <!-- BEGIN: Pagination Table -->
                      <div class="vgt-wrap__footer vgt-clearfix">
                        <div class="footer__row-count vgt-pull-left">
                          <label
                            class="footer__row-count__label row_per_page_label"
                          >
                            Rows per page:
                          </label>
                          <select
                            class="footer__row-count__select row_per_page_option"
                            v-model="paginate"
                            @change="list()"
                          >
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                        </div>
                        <div class="footer__navigation vgt-pull-right">
                          <button
                            type="button"
                            class="footer__navigation__page-btn"
                            :class="{
                              disabled: !outbounds.prev_page_url,
                            }"
                            @click="
                              outbounds.prev_page_url &&
                                list(outbounds.prev_page_url)
                            "
                            style="margin-right: 0px"
                          >
                            <span
                              aria-hidden="true"
                              class="chevron left"
                            ></span>
                            <span class="paginate_text">Prev</span>
                          </button>
                          <div
                            class="footer__navigation__page-info"
                            style="color: #99a0b2"
                          >
                            <label
                              class="page-info__label"
                              style="margin-bottom: -5px"
                            >
                              <span class="paginate_text">page</span>
                              <input
                                type="text"
                                class="footer__navigation__page-info__current-entry vgt-input"
                                v-model="current_page"
                                @keypress="directPage"
                                style="width: 60px"
                              />
                              <span class="paginate_text">
                                of
                                {{ outbounds.last_page }}
                              </span>
                            </label>
                          </div>
                          <button
                            type="button"
                            class="footer__navigation__page-btn"
                            :class="{
                              disabled: !outbounds.next_page_url,
                            }"
                            @click="
                              outbounds.next_page_url &&
                                list(outbounds.next_page_url)
                            "
                          >
                            <span style="font-weight: 500">Next</span>
                            <span
                              aria-hidden="true"
                              class="chevron right"
                            ></span>
                          </button>
                        </div>
                      </div>
                      <!-- END: Pagination Table -->
                    </div>
                  </div>
                </div>
                <!-- END: Tampil Data -->
              </div>
            </div>
            <!-- END: Card -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import debounce from "lodash/debounce";
import moment from "moment";
import Swal from "sweetalert2";

moment.locale("id");

export default {
  data() {
    return {
      outbounds: {
        data: [],
        links: [],
      },
      // Search Data
      search: null, // Search Data Global
      search_kode_barang: null,
      search_nama_barang: null,
      search_satuan: null,
      search_jumlah_barang: null,
      search_jenis_bc: null,
      search_nama_airlines: null,
      search_tanggal_pengeluaran: null,
      search_nama_gudang: null,
      search_aircraft_registration: null,
      search_date_aircraft_in: null,
      search_date_aircraft_out: null,
      search_nomor_aju: null,
      search_tanggal_aju: null,
      search_tanggal_ttd: null,
      search_cif_rupiah: null,
      search_nomor_daftar: null,
      search_tanggal_daftar: null,
      search_matdoc_item: null,
      // Order By
      order: "TANGGAL_PENGELUARAN",
      by: "desc",
      paginate: "10",
      current_page: null,

      // Filter
      filter_start_date_outbound: null,
      filter_end_date_outbound: null,
      filter_start_date_aju: null,
      filter_end_date_aju: null,
      filter_jenis_bc: [],
    };
  },
  methods: {
    list(paginate) {
      this.showLoading();
      paginate = paginate || `/api/outbound-transaction-2`;
      axios
        .get(paginate, {
          params: {
            search: this.search,
            search_kode_barang: this.search_kode_barang,
            search_nama_barang: this.search_nama_barang,
            search_satuan: this.search_satuan,
            search_jumlah_barang: this.search_jumlah_barang,
            search_jenis_bc: this.search_jenis_bc,
            search_nama_airlines: this.search_nama_airlines,
            search_tanggal_pengeluaran: this.search_tanggal_pengeluaran,
            search_nama_gudang: this.search_nama_gudang,
            search_aircraft_registration: this.search_aircraft_registration,
            search_date_aircraft_in: this.search_date_aircraft_in,
            search_date_aircraft_out: this.search_date_aircraft_out,
            search_nomor_aju: this.search_nomor_aju,
            search_tanggal_aju: this.search_tanggal_aju,
            search_tanggal_ttd: this.search_tanggal_ttd,
            search_cif_rupiah: this.search_cif_rupiah,
            search_nomor_daftar: this.search_nomor_daftar,
            search_tanggal_daftar: this.search_tanggal_daftar,
            search_matdoc_item: this.search_matdoc_item,
            filter_start_date_outbound: this.filter_start_date_outbound,
            filter_end_date_outbound: this.filter_end_date_outbound,
            filter_start_date_aju: this.filter_start_date_aju,
            filter_end_date_aju: this.filter_end_date_aju,
            filter_jenis_bc: this.filter_jenis_bc,
            order: this.order,
            by: this.by,
            paginate: this.paginate,
          },
        })
        .then((response) => {
          this.outbounds = response.data;
          this.current_page = this.outbounds.current_page;
          Swal.close();
          this.showSuccessRequest();
        })
        .catch((error) => {
          Swal.close();
          this.showErrorRequest();
          console.log(error);
        });
    },
    exportExcel() {
      this.showLoading();
      axios
        .get("/api/outbound-transaction-2-excel", {
          params: {
            search: this.search,
            search_kode_barang: this.search_kode_barang,
            search_nama_barang: this.search_nama_barang,
            search_satuan: this.search_satuan,
            search_jumlah_barang: this.search_jumlah_barang,
            search_jenis_bc: this.search_jenis_bc,
            search_nama_airlines: this.search_nama_airlines,
            search_tanggal_pengeluaran: this.search_tanggal_pengeluaran,
            search_nama_gudang: this.search_nama_gudang,
            search_aircraft_registration: this.search_aircraft_registration,
            search_date_aircraft_in: this.search_date_aircraft_in,
            search_date_aircraft_out: this.search_date_aircraft_out,
            search_nomor_aju: this.search_nomor_aju,
            search_tanggal_aju: this.search_tanggal_aju,
            search_tanggal_ttd: this.search_tanggal_ttd,
            search_cif_rupiah: this.search_cif_rupiah,
            search_nomor_daftar: this.search_nomor_daftar,
            search_tanggal_daftar: this.search_tanggal_daftar,
            search_matdoc_item: this.search_matdoc_item,
            filter_start_date_outbound: this.filter_start_date_outbound,
            filter_end_date_outbound: this.filter_end_date_outbound,
            filter_start_date_aju: this.filter_start_date_aju,
            filter_end_date_aju: this.filter_end_date_aju,
            filter_jenis_bc: this.filter_jenis_bc,
            order: this.order,
            by: this.by,
            paginate: this.paginate,
          },
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "outbound-transaction-two.xlsx");
          document.body.appendChild(link);
          link.click();
          Swal.close();
          this.showSuccessExport();
        })
        .catch((error) => {
          Swal.close();
          this.showErrorExport();
          console.log(error);
        });
    },
    exportCsv() {
      this.showLoading();
      axios
        .get("/api/outbound-transaction-2-csv", {
          params: {
            search: this.search,
            search_kode_barang: this.search_kode_barang,
            search_nama_barang: this.search_nama_barang,
            search_satuan: this.search_satuan,
            search_jumlah_barang: this.search_jumlah_barang,
            search_jenis_bc: this.search_jenis_bc,
            search_nama_airlines: this.search_nama_airlines,
            search_tanggal_pengeluaran: this.search_tanggal_pengeluaran,
            search_nama_gudang: this.search_nama_gudang,
            search_aircraft_registration: this.search_aircraft_registration,
            search_date_aircraft_in: this.search_date_aircraft_in,
            search_date_aircraft_out: this.search_date_aircraft_out,
            search_nomor_aju: this.search_nomor_aju,
            search_tanggal_aju: this.search_tanggal_aju,
            search_tanggal_ttd: this.search_tanggal_ttd,
            search_cif_rupiah: this.search_cif_rupiah,
            search_nomor_daftar: this.search_nomor_daftar,
            search_tanggal_daftar: this.search_tanggal_daftar,
            search_matdoc_item: this.search_matdoc_item,
            filter_start_date_outbound: this.filter_start_date_outbound,
            filter_end_date_outbound: this.filter_end_date_outbound,
            filter_start_date_aju: this.filter_start_date_aju,
            filter_end_date_aju: this.filter_end_date_aju,
            filter_jenis_bc: this.filter_jenis_bc,
            order: this.order,
            by: this.by,
            paginate: this.paginate,
          },
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "outbound-transaction-two.csv");
          document.body.appendChild(link);
          link.click();
          Swal.close();
          this.showSuccessExport();
        })
        .catch((error) => {
          Swal.close();
          this.showErrorExport();
          console.log(error);
        });
    },
    filterButton() {
      this.list();
    },
    showLoading() {
      Swal.fire({
        didOpen: () => {
          Swal.showLoading();
        },
        background: "transparent",
        allowOutsideClick: false,
      });
    },
    showSuccessRequest() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Successfully Retrieve Data",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    showErrorRequest() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Failed to Retrieve Data",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    showSuccessExport() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Successfully Export Data",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    showErrorExport() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Failed to Export Data",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    clearForm() {
      this.outbounds = {
        data: [],
        links: [],
      };
      this.search = null;
      this.search = null;
      this.search_kode_barang = null;
      this.search_nama_barang = null;
      this.search_satuan = null;
      this.search_jumlah_barang = null;
      this.search_jenis_bc = null;
      this.search_nama_airlines = null;
      this.search_tanggal_pengeluaran = null;
      this.search_aircraft_registration = null;
      this.search_date_aircraft_in = null;
      this.search_date_aircraft_out = null;
      this.search_nomor_aju = null;
      this.search_tanggal_aju = null;
      this.search_tanggal_ttd = null;
      this.search_cif_rupiah = null;
      this.search_nomor_daftar = null;
      this.search_tanggal_daftar = null;
      this.search_matdoc_item = null;
      this.filter_start_date_outbound = null;
      this.filter_end_date_outbound = null;
      this.filter_start_date_aju = null;
      this.filter_end_date_aju = null;
      this.filter_jenis_bc = null;
    },
    directPage: debounce(function () {
      if (this.current_page < 1) {
        this.current_page = 1;
      } else if (this.current_page > this.outbounds.last_page) {
        this.current_page = this.outbounds.last_page;
      }
      let url = new URL(this.outbounds.first_page_url);
      let search_params = url.searchParams;
      search_params.set("page", this.current_page);
      url.search = search_params.toString();
      let new_url = url.toString();
      this.list(new_url);
    }, 500),
    sort(order, by) {
      this.order = order;
      this.by = by;
      this.list();
    },
  },
};
</script>
<style scoped>
.vgt-global-search__input .input__icon .magnifying-glass {
  margin-top: -3px;
}
</style>
